<!-- 课程管理 添加 -->
<template>
  <div class="course_scheduling_card">
    <div>
      <span class="font_base">课程名称：{{dataform.title}}</span>
    </div>
    <div>
      <div class="font_base line-item">开始时间：<p>{{dataform.starttime}}</p></div>
      <el-time-select placeholder="开始时间：" 
        v-if="isEdit"
        v-model="starttime" 
        :picker-options="timePickerOption"></el-time-select>
    </div>
    <div>
      <div class="font_base line-item">结束时间：<p>{{dataform.endtime}}</p></div>
      <el-time-select placeholder="结束时间：" 
        v-if="isEdit"
        v-model="endtime" 
        :picker-options="timePickerOption"></el-time-select>

    </div>
    <div class="close" @click="onClickRemove">
      <i class="el-icon-close"></i>
    </div>
    <div>
      <el-button @click="onClickEdit" v-show="!isEdit">修改</el-button>
      <el-button @click="onClickConfirm" v-show="isEdit">确认</el-button>
    </div>

    <!-- <template v-if="editMode">
      <el-button type="primary" @click="update" :loading="loading">更新</el-button>
    </template> -->
  </div>
</template>

<script>
export default {
  name: "CourseSchedulingCard",
  props:{
    timetype:{
      type: Number
    },
    course: {
      type: Object
    }

  },
  data() {
    return {
      starttime: "",
      endtime: "",

      dataform: {

        id: "",
        title: "",
        starttime: "",
        endtime: "",
      },

      isEdit : false
    }
  },
  methods:{
    init(){
      this.dataform.id = this.course.id
      this.dataform.title = this.course.title
      this.dataform.starttime = this.course.starttime
      this.dataform.endtime = this.course.endtime
    },
    
    onClickEdit(){
      this.isEdit = true;
    },

    onClickConfirm(){

      if(this.starttime){
        this.dataform.starttime = this.starttime;
        this.course.starttime = this.starttime;
      }

      if(this.endtime){
        this.dataform.endtime = this.endtime;
        this.course.endtime = this.endtime;
      }

      this.isEdit = false;

    },

    onClickRemove(){
      this.$emit("onClickRemove");
    }
  },
  watch:{
    title(oldVal,newVal){

    },

  },
  
  computed:{
    timePickerOption(){
      if (this.timetype == 0) {
        return {
          start: "06:00",
          step: "00:15",
          end: "12:00",
        };
      } else if (this.timetype == 1) {
        return {
          start: "12:00",
          step: "00:15",
          end: "18:00",
        };
      } else if (this.timetype == 2) {
        return {
          start: "18:00",
          step: "00:15",
          end: "24:00",
        };
      } else {
        return {
          start: "06:00",
          step: "00:15",
          end: "24:00",
        };
      }
    }
  },
  
  created() {
    this.init();

  },
  mounted(){

  }
};
</script>



<style scoped lang="scss">
.course_scheduling_card {
  margin-bottom: 10px;
  border: 1px solid #dcdfe6;
  line-height: 50px;
  box-sizing: border-box;
  margin-right: 10px;
  padding: 20px;
  position: relative;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  .close {
    font-size: 14px;
    position: absolute;
    top: -8px;
    right: 7px;
    &:hover {
      cursor: pointer;
    }
  }
}

.line-item{
  display: flex;
  align-items: center;
  justify-content: flex-start;

}
</style>

